import {Checkbox, Flex, theme, Typography} from 'antd';
import React from 'react';
import {dateConversionIsoToLocal, isValidISO8601} from 'Utils/helpers/DateValidation';

interface IProps {
  label: string;
  value?: any;
  type?: string;
}

const AdminDetailListItem: React.FC<IProps> = (props) => {
  const {label, value, type} = props;
  const {token}: any = theme.useToken();

  return (
    <Flex align="center" style={{flex: 1, marginBottom: 5}}>
      <Typography.Text style={{width: 100}}>{label}</Typography.Text>
      {type === 'checkbox' ? (
        <Checkbox checked={value} disabled style={{width: '100%'}} />
      ) : (
        <Typography.Text
          style={{
            display: 'flex',
            flex: 2,
            marginLeft: 4,
            border: `1px solid ${token.colorBorder}`,
            justifyContent: 'center',
            borderRadius: 10,
            padding: '0 4px',
            boxShadow: token.boxShadowTertiary,
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}>
          {isValidISO8601(value) ? dateConversionIsoToLocal(value) : value || '-'}
        </Typography.Text>
      )}
    </Flex>
  );
};

export default AdminDetailListItem;
